import { useEffect, useState } from 'react';
import moment from 'moment';

import { Badge } from 'react-bootstrap';
import { TableCell, TableRow, } from '@material-ui/core';;

import './newChamadoStyles.css';

import history from '../../history';


const refreshPage = () => {
  window.location.reload()
}


const CorpoChamado = ({ data }) => {
  const [status, setStatus] = useState('')
  const [statusColor, setStatusColor] = useState('light')

  function handleClick() {
    history.push('/Chamados/unico')
    localStorage.setItem('id', data.id)
    refreshPage()
  }

  useEffect(() => {
    ;(async () => {
      if (data.status === 'Concluido') {
        setStatusColor('success')
        return setStatus('Concluido')
      } else if (data.status === 'Em atendimento') {
        setStatusColor('warning')
        return setStatus('Em atendimento')
      } else if (data.status === 'Aberto') {
        setStatusColor('warning')
        return setStatus('Aberto')
      } else {
        setStatusColor('danger')
        return setStatus('Sem status')
      }
    })()
  }, [])


  return (
    <TableRow>
      <TableCell className="trTableChamados" onClick={handleClick} align="center">
        {data.idEmpresa}
      </TableCell>
      <TableCell  className="trTableChamados" onClick={handleClick} align="center">
        {data.assunto}
      </TableCell>
      <TableCell className="trTableChamados" onClick={handleClick} align="center">
        <Badge variant={statusColor} align="center">
          {status}
        </Badge>
      </TableCell>
      <TableCell  className="trTableChamados" onClick={handleClick} align="center">
        {data.tecnico}
      </TableCell>

      <TableCell  className="trTableChamados" align="center">
        { moment(data.data_abertura).format('DD/MM/YY') }
      </TableCell>
    </TableRow>
  );
}

export default CorpoChamado;
